import React from "react";
import { Link } from "react-router-dom";
import Loader from "./loader";

const CustomLink = ({
  iconLeft,
  iconRight,
  text,
  iconSize = 25,
  href,
  link,
  button = false,
  customClassName = "",
  onClick,
  showLoader = false,
}) => {
  const className = `inline-flex items-center justify-center gap-2 transition-all duration-300 ${!showLoader && "cursor-pointer"} ${button
      ? `text-white bg-fg font-semibold py-2 px-4 rounded-lg ${!showLoader && "hover:bg-blue-600"} shadow-lg`
      : `text-white hover:text-fg`
    } ${customClassName}`;

  if (showLoader) {
    iconLeft = <Loader show={showLoader} className={"w-5 h-5 fill-white"} />;
  }

  if (link) {
    return (
      <button onClick={onClick} disabled={showLoader} className="">
        <Link to={link} className={className}>
          {iconLeft && React.cloneElement(iconLeft, { size: iconSize })}
          {text}
          {iconRight && React.cloneElement(iconRight, { size: iconSize })}
        </Link>
      </button>
    );
  }

  return (
    <button onClick={onClick} disabled={showLoader} className={className}>
      {iconLeft && React.cloneElement(iconLeft, { size: iconSize })}
      {text}
      {iconRight && React.cloneElement(iconRight, { size: iconSize })}
    </button>
  );
};

export default CustomLink;
